import * as actions from './actions';
import { ReduxUtils } from '@dw/pwa-helpers/redux-utils';

const INITIAL_STATE = {};

export const chatReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.ALL_TOP_BOARD_CHATS_LOADED:
      return ReduxUtils.replace(state, `allTopBoardChatsLoaded`, true);
    case actions.ALL_BOTTOM_BOARD_CHATS_LOADED:
      return ReduxUtils.replace(state, `allBottomBoardChatsLoaded`, true);
    case actions.RESET_BOARD_CHATS:
      return ReduxUtils.replace(state, `boardChats`, null);
    case actions.ADD_MESSAGE:
      return ReduxUtils.replace(state, `addNewChat.${action.cardId || action.boardId}.status`, 'IN_PROGRESS');
    case actions.ADD_MESSAGE_SUCCESS:
      return ReduxUtils.replace(state, `addNewChat.${action.cardId || action.boardId}.status`, 'SUCCESS');
    case actions.ADD_MESSAGE_FAILED:
      return ReduxUtils.replace(state, `addNewChat.${action.cardId || action.boardId}.status`, 'FAILED');
    case actions.UPDATE_NEW_CHAT_DRAFT: {
      if (!action.containerId) {
        return state;
      }

      // An empty draft is an absent one: `undefined` drops the key rather than leaving one behind
      // for every container the user has ever typed in and then cleared.
      const draft = (action.message || '').trim() || undefined;
      return ReduxUtils.replace(state, `newChatDrafts.${action.containerId}`, draft);
    }
    case actions.UPDATE_EDIT_DRAFT: {
      if (!action.chatMessageId) {
        return state;
      }

      const draft = (action.message || '').trim() || undefined;
      return ReduxUtils.replace(state, `editDrafts.${action.chatMessageId}`, draft);
    }
    case actions.SET_OPEN_EDIT:
      return ReduxUtils.replace(state, 'openEditId', action.chatMessageId || undefined);
    case actions.CLEAR_DRAFTS:
      return { ...state, newChatDrafts: undefined, editDrafts: undefined };
    default:
      return state;
  }
};